import { z } from 'zod';

export const WorkstreamState = {
    enabled: 'enabled',
    disabled: 'disabled'
} as const;

const enumType = z.enum(WorkstreamState);
type EnumType = z.infer<typeof enumType>

const extraEnabled = [ 'true', 'on' ];
const extraDisabled = [ 'false', 'off' ];
const boolConversions = ({
    decode: (val: boolean): EnumType => val
        ? WorkstreamState.enabled
        : WorkstreamState.disabled,
    encode: (val: EnumType): boolean => val === WorkstreamState.enabled
});

/**
 * The state of a workstream: 'enabled' or 'disabled'.
 * @remarks This uses a zod codec to map 'enabled', 'true', or 'on' to 'enabled' and 'disabled', 'false', 'off' to 'disabled'.
 */
export const WorkstreamStateSchema = z.codec(
    z.boolean().or(
        z.stringbool({
            truthy: [ WorkstreamState.enabled, ...extraEnabled ],
            falsy: [ WorkstreamState.disabled, ...extraDisabled ],
            case: 'insensitive'
        })),
    enumType,
    boolConversions
);

export type WorkstreamState = z.infer<typeof WorkstreamStateSchema>;
